import Model from '@/models/Model'

export default class SlCustomerAccountReceivablePending extends Model {
	static includes = [
		'sl_sale_debit_note',
		'sl_sale_invoice',
	]
	get created_at() {
		return this.sl_sale_invoice ? 
			this.sl_sale_invoice.created_at 
			: 
			this.sl_sale_debit_note ? 
				this.sl_sale_debit_note.created_at 
				: 
				'-'
	}
	get number() {
		return this.sl_sale_invoice ? 
			this.sl_sale_invoice.number 
			: 
			this.sl_sale_debit_note ? 
				this.sl_sale_debit_note.number 
				: 
				'-'
	}
  resource() {
    return 'sl_customer_account_receivable_pending'
  }
  /*toList() {
  	return this.include('sl_sale_invoice')
  }*/
}